<template>
      <!--div class="d-flex justify-content-center p-1" style="background: #d3e5f7">
        <img class="" style=" max-height: 120px; object-fit:contain;  " src="@/assets/header2.png"/>


      </div-->

</template>

<script>
import {
} from "@ionic/vue";
import { isPlatform } from '@ionic/vue';

export default {
  name: 'Header',
  components: {
  },
  data() {
    return {
      isDesktop: null,
    }
  },
  computed: {
  },
  methods: {
 
  
  },
  async created() {
    this.isDesktop= isPlatform('desktop');
  }
};
</script>
<style lang="scss">



</style>
